export interface SystemJobLog {
  id: number;
  systemJobID: number;
  syncQueueID: number;
  name: string;
  beginDateTime: Date;
  endDateTime: Date;
  minutesToComplete: number;
  status: string;
  comment: string;
}

export const emptySystemJobLog: SystemJobLog = {
  id: null,
  systemJobID: null,
  syncQueueID: null,
  name: '',
  beginDateTime: null,
  endDateTime: null,
  minutesToComplete: null,
  status: '',
  comment: ''
};
